import type {
  FindProductionSiteRequestByUserResponseDto,
  ProductionSiteFieldValueDto,
} from "~/gen/api"
import { getCustomFieldParser } from "~/pages/SupplierPortal/TraceabilityRequests/components/getCustomFieldParser.ts"

export function isProdsiteFieldValueSubmitted(
  fieldValue: ProductionSiteFieldValueDto
): boolean {
  return fieldValue.submittedAt !== null
}

export function isProdsiteFieldValueTransferred(
  fieldValue: ProductionSiteFieldValueDto,
  userId: string
): boolean {
  return (
    isProdsiteFieldValueSubmitted(fieldValue) &&
    fieldValue.submittedById !== userId
  )
}

export function canEditProdsiteFieldValue(
  submittedById: string | null | undefined,
  userId: string | undefined,
  isRepresentedPartnerView = false
): boolean {
  if (!userId) {
    return false
  }

  if (isRepresentedPartnerView) {
    return true
  }

  if (!submittedById) {
    return false
  }

  return submittedById === userId
}

export function isProdsiteFieldRequestSubmitted(
  pfr: FindProductionSiteRequestByUserResponseDto,
  userId: string,
  isRepresentedPartnerView = false
): boolean {
  return pfr.prodsiteFieldValues.every((fieldValue) => {
    return (
      isProdsiteFieldValueSubmitted(fieldValue) ||
      !canEditProdsiteFieldValue(
        fieldValue.submittedById,
        userId,
        isRepresentedPartnerView
      )
    )
  })
}

export function isProdsiteFieldRequestValid(
  pfr: FindProductionSiteRequestByUserResponseDto,
  userId: string | undefined,
  isRepresentedPartnerView = false
): boolean {
  if (!userId) {
    return false
  }

  return pfr.prodsiteFieldValues.every(
    (psfv) =>
      !canEditProdsiteFieldValue(
        psfv.submittedById,
        userId,
        isRepresentedPartnerView
      ) ||
      isProdsiteFieldValueSubmitted(psfv) ||
      fieldIsValid(psfv)
  )
}

function fieldIsValid(cfv: ProductionSiteFieldValueDto): boolean {
  const value = cfv.value

  if (value === "") {
    return false
  }
  const cfd = cfv.prodsiteFieldDefinition
  const enumValues = cfd.enumValuesTranslated.map((x) => x.originalText)
  const parser = getCustomFieldParser(cfd, enumValues)
  return parser.safeParse(value).success
}
